import { AppRouteProps } from "@harea/component";
import React from "react";

const UsersContainer = React.lazy(() => import('./containers/UserOrganisationInvitationList'))

export const UsersRoutes: Array<AppRouteProps> = [
    {
        path: 'users',
        title: "Generic.UserOrganisation.About.title",
        element: <UsersContainer />,
        roles: ["SUPER_ADMIN", "ADMIN", "DIRECTOR_HR"],
    }
]